import { render, staticRenderFns } from "./IntakeWiseStudentList.vue?vue&type=template&id=5c99de87&"
import script from "./IntakeWiseStudentList.vue?vue&type=script&lang=js&"
export * from "./IntakeWiseStudentList.vue?vue&type=script&lang=js&"
import style0 from "./IntakeWiseStudentList.vue?vue&type=style&index=0&id=5c99de87&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports